import React, { useEffect, memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as R from 'ramda';
import { fetchLayerConfig } from '@actions/layers-actions';
import Layers from './layers';

const LayerList = () => {
  const dispatch = useDispatch();
  const layers = useSelector(state => state?.layers);

  useEffect(() => {
    // Fetch data on load.
    if (R.isEmpty(layers)) {
      dispatch(fetchLayerConfig());
    }
  }, [dispatch]);  // eslint-disable-line react-hooks/exhaustive-deps
                   // Don't put layers in the dependency array, so they are only loaded once
                   // (some cities might not have layers, which would trigger an endless layer fetch otherwise).

  return Object.keys(layers).map(name => {
    if (layers[name].editDisplay && layers[name].editDisplay === true) {
      return <Layers key={`layer-${name}`} {...layers[name]} />;
    }
    return null;
  });
};

export default memo(LayerList);
